import { render, staticRenderFns } from "./withdrawal-detail.vue?vue&type=template&id=d87ef528&scoped=true&"
import script from "./withdrawal-detail.vue?vue&type=script&lang=js&"
export * from "./withdrawal-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-detail.vue?vue&type=style&index=0&id=d87ef528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87ef528",
  null
  
)

export default component.exports